// ─── «Accesos al portal»: quién abrió el portal de esta persona ─────────────
// Las aperturas de «Ver portal» quedan en `auditEvents` (`portal_view.opened`,
// las escribe el servidor). Acá solo se ordenan y se les pone nombre. Puro, con
// test.

export interface PortalAccessEvent {
  actor: string;
  actorRole: string | null;
  action: string;
  occurredAt: Date;
}

export interface PortalAccessRow {
  key: string;
  /** Nombre de quien abrió; null = no tiene ficha en el seminario. */
  who: string | null;
  role: 'platformAdmin' | 'tenantAdmin' | 'registrar' | 'other';
  at: Date;
}

const ROLES = new Set(['platformAdmin', 'tenantAdmin', 'registrar']);

/** Solo las aperturas, la más reciente primero, a lo sumo `limit`. */
export function portalAccessRows(
  events: readonly PortalAccessEvent[],
  namesByUid: ReadonlyMap<string, string>,
  limit = 20,
): PortalAccessRow[] {
  return events
    .filter((e) => e.action === 'portal_view.opened')
    .sort((a, b) => b.occurredAt.getTime() - a.occurredAt.getTime())
    .slice(0, limit)
    .map((e, i) => ({
      key: `${e.actor}-${e.occurredAt.getTime()}-${i}`,
      who: namesByUid.get(e.actor) ?? null,
      role: (e.actorRole && ROLES.has(e.actorRole)
        ? e.actorRole
        : 'other') as PortalAccessRow['role'],
      at: e.occurredAt,
    }));
}

/** Los uid a los que hay que ponerles nombre (sin repetir). */
export function actorsOf(events: readonly PortalAccessEvent[]): string[] {
  return [...new Set(events.filter((e) => e.action === 'portal_view.opened').map((e) => e.actor))];
}
